// export const addressServer = "http://localhost:1337";
export const addressServer = "https://mosoblenergo.ru/back";
//export const addressServer = "http://176.114.67.112:1337";
export const chargingAddressServer = "https://nopowersupply.mosoblenergo.ru/station";